<div class='fullcontainer-noBg mb-3 p-3'>
  <div class="dashboardHeader">
    <h2>Dashboard</h2>
    <p>Welcome back{{ this.user.firstName ? ', ' + this.user.firstName : '' }}</p>
  </div>

  <div class="dateRangeRow">
    <div class="dateField">
      <label>Start Date</label>
      <input class='form-control' type='date' [(ngModel)]='this.startDate'/>
    </div>
    <div class="dateField">
      <label>End Date</label>
      <input class='form-control' type='date' [(ngModel)]='this.endDate'/>
    </div>
    <button class='btn btn-success' (click)='updateDate()'>Update Date Range</button>
  </div>

  <app-accounts-orders-stats-row class="mt-3 d-block" [startDate]='this.startDate' [endDate]='this.endDate'></app-accounts-orders-stats-row>

  <div class="row ml-5 mt-3">
    <div class="col m-2 graph-block">
      <app-orders-by-status-graph [startDate]='this.startDate' [endDate]='this.endDate'></app-orders-by-status-graph>
    </div>
    <div class="col m-2 graph-block">
      <app-jobs-this-week-graph [startDate]='this.startDate' [endDate]='this.endDate'></app-jobs-this-week-graph>
    </div>
    <div class="col m-2 graph-block">
      <app-vehicle-fleet-status-graph></app-vehicle-fleet-status-graph>
    </div>
    <div class="col m-2 graph-block">
      <app-open-vehicle-defects></app-open-vehicle-defects>
    </div>
  </div>
</div>
